export function processSearchResultItemData(item) {
  if (!item?.[0] || !item?.[0]?.locales) {
    return null;
  }

  const processedItem = item[0];
  return formatItem(processedItem);
}

export function formatItem(item) {
  const images = Object.values(item.locales)[0]?.images;
  const primaryImage = images?.primary?.large?.url;
  const imageUrls = [
    primaryImage,
    ...(images?.variants?.map((variant) => variant?.large?.url) || []),
  ].filter((url, index, all) => url && all.indexOf(url) === index);

  const locales = Object.entries(item.locales).map(([locale, data]) => ({
    locale,
    ...data,
  }));

  return {
    amazonIndex: item.amazonIndex,
    id: item.ASIN,
    title: item.title,
    fullTitle: item.fullTitle,
    description: item.description,
    primaryImage,
    images: imageUrls,
    locales,
    dealAnalysis: item.dealAnalysis,
    freeShippingToIsrael: item.freeShippingToIsrael,
    shippingCostToIsrael: item.shippingCostToIsrael,
    isTracking: item.isTracking,
  };
}
